import Alpine from "alpinejs";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

Alpine.data('teamCarousel', () => ({
    swiper: null,
    activeItem: 0,
    init() {
        this.swiper = new Swiper(this.$refs.carousel, {
            autoplay: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoHeight: true,
            breakpoints: {
                320: {
                    autoplay: true,
                },
                640: {
                    autoplay: false,
                },
            },
            modules: [Navigation, Pagination],
            navigation: {
                disabledClass: 'opacity-50 pointer-events-none',
                hiddenClass: 'hidden',
                nextEl: '.teamNext',
                prevEl: '.teamPrev',
            },
            pagination: {
                el: this.$refs.pagination,
                clickable: true,
                bulletClass: 'block transition h-2.5 w-2.5 rounded-full bg-white border-2 opacity-50',
                bulletActiveClass: '!opacity-100',
                clickableClass: 'cursor-pointer',
            },
            watchSlidesProgress: true,
  
            on: {
                // This event fires continuously during any swiper movement
                progress: function() {
                    const swiper = this;
                    
                    // Loop through each slide
                    for (let i = 0; i < swiper.slides.length; i++) {
                      const slide = swiper.slides[i];
                      const slideProgress = slide.progress;

                      let opacity = 1;
                      if (slideProgress > 0) {
                        // For slides to the left of active slide
                        opacity = 1 - (slideProgress * 1.6); // This will go from 1 to 0 as slideProgress goes from 0 to -1
                      }
                      
                      // Apply opacity to the slide
                      slide.style.opacity = Math.max(0, Math.min(1, opacity));
                    }
              
        },
            },
            
                
            // Reset the effect when touch/transition ends
            setTransition: function(speed) {
                const swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].style.transition = `${speed}ms`;
                }
            },
        });

        
        this.swiper.on('slideChange', () => {
            this.activeItem = this.swiper.realIndex;
            console.log('change', this.activeItem);
        });

        // let totalSlides = this.swiper.slides.length;
        // this.swiper.on('progress', (swiper, progress) => {
        //     console.log('progress', progress);

        //     // Progress is the entire progress of the swiper, from 0 to 1, for each slide, if left of the active slide, reduce the opacity to 0
        //     // e.g. with 3 slides, the progress will be 0.33 for the first slide, 0.66 for the second slide, and 1 for the third slide
        //     // Opacity should be reduced dynamically based on the progress of the swiper, not with fixed classes, the opacity value should be calculated based on the progress
        //     // The active slide should always have an opacity of 1
        //     let activeSlide = totalSlides / progress;

        //     this.swiper.slides.forEach((slide, index) => {
                
        //         if (index < this.activeItem) {
        //             slide.style.opacity = 1 - progress;
        //         } else {
        //             slide.style.opacity = 1;
        //         }
        //     });


        // });
    },
    setActiveSlide(index) {
        this.swiper.slideTo(index);
    },
    destroy() {
        this.swiper.destroy();
    },
}));

Alpine.data('caseStudiesCarousel', () => ({
    swiper: null,
    activeItem: 0,
    init() {
        this.swiper = new Swiper(this.$refs.carousel, {
            autoplay: true,
            slidesPerView: 1.3,
            spaceBetween: 30,
            autoHeight: true,
            breakpoints: {
                320: {
                    autoplay: true,
                },
                640: {
                    autoplay: false,
                    slidesPerView: 3,
                },
            },
            modules: [Navigation],
            navigation: {
                disabledClass: 'opacity-50 pointer-events-none',
                hiddenClass: 'hidden',
                nextEl: '.next',
                prevEl: '.prev',
            },
        });
        
        this.swiper.on('slideChange', () => {
            this.activeItem = this.swiper.realIndex;
            console.log('change', this.activeItem);
        });

        // let totalSlides = this.swiper.slides.length;
        // this.swiper.on('progress', (swiper, progress) => {
        //     console.log('progress', progress);

        //     // Progress is the entire progress of the swiper, from 0 to 1, for each slide, if left of the active slide, reduce the opacity to 0
        //     // e.g. with 3 slides, the progress will be 0.33 for the first slide, 0.66 for the second slide, and 1 for the third slide
        //     // Opacity should be reduced dynamically based on the progress of the swiper, not with fixed classes, the opacity value should be calculated based on the progress
        //     // The active slide should always have an opacity of 1
        //     let activeSlide = totalSlides / progress;

        //     this.swiper.slides.forEach((slide, index) => {
                
        //         if (index < this.activeItem) {
        //             slide.style.opacity = 1 - progress;
        //         } else {
        //             slide.style.opacity = 1;
        //         }
        //     });


        // });
    },
    setActiveSlide(index) {
        this.swiper.slideTo(index);
    },
    destroy() {
        this.swiper.destroy();
    },
}));

Alpine.data('articlesCarousel', () => ({
    swiper: null,
    activeItem: 0,
    init() {
        this.swiper = new Swiper(this.$refs.carousel, {
            autoplay: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
            autoHeight: true,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    
                },
            },
            modules: [Navigation],
            navigation: {
                disabledClass: 'opacity-50 pointer-events-none',
                hiddenClass: 'hidden',
                nextEl: this.$refs.next,
                prevEl: this.$refs.prev,
            },
        });
        
        this.swiper.on('slideChange', () => {
            this.activeItem = this.swiper.realIndex;
            console.log('change', this.activeItem);
        });

        // let totalSlides = this.swiper.slides.length;
        // this.swiper.on('progress', (swiper, progress) => {
        //     console.log('progress', progress);

        //     // Progress is the entire progress of the swiper, from 0 to 1, for each slide, if left of the active slide, reduce the opacity to 0
        //     // e.g. with 3 slides, the progress will be 0.33 for the first slide, 0.66 for the second slide, and 1 for the third slide
        //     // Opacity should be reduced dynamically based on the progress of the swiper, not with fixed classes, the opacity value should be calculated based on the progress
        //     // The active slide should always have an opacity of 1
        //     let activeSlide = totalSlides / progress;

        //     this.swiper.slides.forEach((slide, index) => {
                
        //         if (index < this.activeItem) {
        //             slide.style.opacity = 1 - progress;
        //         } else {
        //             slide.style.opacity = 1;
        //         }
        //     });


        // });
    },
    setActiveSlide(index) {
        this.swiper.slideTo(index);
    },
    destroy() {
        this.swiper.destroy();
    },
}));

Alpine.data('variableCarousel', () => ({
    swiper: null,
    activeItem: 0,
    init() {
        this.swiper = new Swiper(this.$refs.carousel, {
            autoplay: true,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 16,
            autoHeight: false,
            breakpoints: {
                640: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 2,
                },
                768: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 3,
                    
                },
            },
            modules: [Navigation],
            navigation: {
                disabledClass: 'opacity-50 pointer-events-none',
                hiddenClass: 'hidden',
                nextEl: '.next',
                prevEl: '.prev',
            },
        });
        
        this.swiper.on('slideChange', () => {
            this.activeItem = this.swiper.realIndex;
            console.log('change', this.activeItem);
        });

        // let totalSlides = this.swiper.slides.length;
        // this.swiper.on('progress', (swiper, progress) => {
        //     console.log('progress', progress);

        //     // Progress is the entire progress of the swiper, from 0 to 1, for each slide, if left of the active slide, reduce the opacity to 0
        //     // e.g. with 3 slides, the progress will be 0.33 for the first slide, 0.66 for the second slide, and 1 for the third slide
        //     // Opacity should be reduced dynamically based on the progress of the swiper, not with fixed classes, the opacity value should be calculated based on the progress
        //     // The active slide should always have an opacity of 1
        //     let activeSlide = totalSlides / progress;

        //     this.swiper.slides.forEach((slide, index) => {
                
        //         if (index < this.activeItem) {
        //             slide.style.opacity = 1 - progress;
        //         } else {
        //             slide.style.opacity = 1;
        //         }
        //     });


        // });
    },
    setActiveSlide(index) {
        this.swiper.slideTo(index);
    },
    destroy() {
        this.swiper.destroy();
    },
}));